import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';

@Component({
  selector: 'app-modal-open-to-access-curve',
  templateUrl: './modal-open-to-access-curve.component.html',
  styleUrls: ['./modal-open-to-access-curve.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class ModalOpenToAccessCurveComponent implements OnInit, OnDestroy {
  @Output() isModalOpen = new EventEmitter<boolean>();
  @Input() curvePointData: any = {};

  Regioni: any[] = [];
  medicineId: number = 0;
  countryId: number = 1; // Default to Italy
  isLoading: boolean = true;

  constructor (private dataService: DataService) { }

  ngOnInit () {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';

    this.medicineId = sessionStorage.getItem('medicineId') ? parseInt(sessionStorage.getItem('medicineId')!, 10) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? parseInt(sessionStorage.getItem('countryId')!, 10) : 1;

    if (this.curvePointData.type === 'Forecast') {
      this.dataService.getRegionsContributorsOpenToAccess(this.medicineId, this.countryId, this.curvePointData.month).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.Regioni = data
          this.Regioni.sort((a, b) => b.potentialPercentage - a.potentialPercentage);
        },
        error: (err) => {
          this.isLoading = false;
          console.log('error: ', err);
        },
      });
    } else {
      this.dataService.getRegionsContributorsOpenToAccessActual(this.medicineId, this.countryId, this.curvePointData.month).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.Regioni = data
          this.Regioni.sort((a, b) => b.potentialPercentage - a.potentialPercentage);
        },
        error: (err) => {
          this.isLoading = false;
          console.log('error: ', err);
        },
      });
    }

  }

  ngOnDestroy () {
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  closeModal () {
    this.isModalOpen.emit(false);
  }
}
